import {TaxComputationType, type TaxComputationResult} from '@/services/auditService/interface/tax-com';

export const DEFAULT_P1_NOTE = 'Note: The Company was inactive during the period.';

export const DEFAULT_P1_CONFIRM =
    'I have carefully reviewed the contents of this computation and hereby confirm that they accurately reflect my understanding and position.\n'
    + 'I hereby authorize you to submit this computation to the Inland Revenue Department on my behalf.';

export function normalizeTaxComputationType(
    type?: TaxComputationType | string | null,
): TaxComputationType | null {
    if (!type) return null;
    const normalized = String(type).toUpperCase();
    if (normalized === TaxComputationType.TYPE_A || normalized === 'A') {
        return TaxComputationType.TYPE_A;
    }
    if (normalized === TaxComputationType.TYPE_B || normalized === 'B') {
        return TaxComputationType.TYPE_B;
    }
    if (normalized === TaxComputationType.TYPE_C || normalized === 'C') {
        return TaxComputationType.TYPE_C;
    }
    return null;
}

export function getP1NoteConfirmFromResult(mainData?: TaxComputationResult | null): {
    note?: string;
    confirm?: string;
} {
    const type = normalizeTaxComputationType(mainData?.type);
    if (type === TaxComputationType.TYPE_A) {
        return {
            note: mainData?.profitsTaxA?.note,
            confirm: mainData?.profitsTaxA?.confirm,
        };
    }
    if (type === TaxComputationType.TYPE_B) {
        return {
            note: mainData?.profitsTaxB?.note,
            confirm: mainData?.profitsTaxB?.confirm,
        };
    }
    if (type === TaxComputationType.TYPE_C) {
        return {
            note: mainData?.profitsTaxC?.note,
            confirm: mainData?.profitsTaxC?.confirm,
        };
    }
    return {};
}

export function resolveP1DisplayText(
    primary?: string | null,
    fallback?: string | null,
    defaultText?: string,
): string {
    if (primary?.trim()) {
        return primary;
    }
    if (fallback?.trim()) {
        return fallback;
    }
    return defaultText ?? '';
}

/**
 * Editable P1 note/confirm: empty string is a real value.
 * Do not fall back to default "Note:..." while the user is deleting.
 */
export function resolveP1EditableText(
    primary?: string | null,
    fallback?: string | null,
    defaultText?: string,
): string {
    if (primary != null) {
        return primary;
    }
    return resolveP1DisplayText(undefined, fallback, defaultText);
}
